import { defineStore } from 'pinia'
import { apiService } from '@/services/api'

export const useEgovAuthStore = defineStore('egovAuth', {
  state: () => ({
    // 認証状態
    isAuthenticated: false,
    tokenExpiresAt: null,
  }),

  getters: {
    // トークンの有効性をチェック
    isTokenValid: state => {
      // サーバー側で認証管理しているため、isAuthenticatedがtrueなら有効とみなす
      if (state.isAuthenticated && state.tokenExpiresAt) {
        const now = new Date()
        const expiresAt = new Date(state.tokenExpiresAt)
        const isValid = now < expiresAt

        return isValid
      }

      // 認証されていない場合
      return false
    },

    // 認証が必要かどうか
    needsAuthentication: state => {
      // サーバー側で認証管理しているため、isAuthenticatedの状態を基準にする
      return !state.isAuthenticated
    },
  },

  actions: {
    // 認証開始
    async startAuth() {
      try {
        // 現在のURL（クエリパラメータ含む）を取得
        const currentUrl = window.location.href

        // LaravelのAPIから認証URLを取得（現在のURLも送信）
        const response = await apiService.get('api/egov/auth-url', {
          intendedUrl: currentUrl,
        })

        // 認証画面へリダイレクト（Laravel側で元URLを保存済み）
        window.location.href = response.authUrl
      } catch (error) {}
    },

    // 認証が必要かどうかをチェック（必要なら true、不要なら false を返す）
    async checkAuthRequired() {
      try {
        const response = await apiService.get('api/egov/check-auth')

        if (response.isAuthenticated) {
          this.isAuthenticated = true
          this.tokenExpiresAt = response.tokenExpiresAt

          return false // 認証不要
        } else {
          // 認証されていない場合は状態をクリア
          this.clearAuth()
          return true // 認証必要
        }
      } catch (error) {
        this.clearAuth()
        return true // エラー時も認証必要とみなす
      }
    },

    // 認証をクリア
    clearAuth() {
      this.isAuthenticated = false
      this.tokenExpiresAt = null
    },

    // ログアウト
    async logout() {
      try {
        await apiService.post('api/egov/logout')
      } catch (error) {
      } finally {
        this.clearAuth()
      }
    },
  },
})
